import { render, staticRenderFns } from "./VUserPreview.vue?vue&type=template&id=de348390"
import script from "./VUserPreview.vue?vue&type=script&lang=js"
export * from "./VUserPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports